// 根据该模块下的个文件名，来做归类区分：
const zh = {
	header: {
		homepage: '首页',
		websiteManage: '网站管理',
		omniWebsiteManage: '门店/网站管理',
		storeManage: '门店管理',
		websiteManageReview: '提交网站审核',
		omniWebsiteManageReview: '网站管理',
		storeOnboarding: '店铺状态查询',
		chargebackManage: '调单拒付管理',
		withdrawalRecord: '提现记录',
		autoWithdrawalRecord: '自动提现记录',
		logisticsManage: '订单管理',
		transactionAnalysis: '交易分析',
		settlementStatement: '结算报表',
		accountCenter: '账户中心',
		withdrawCenter: '提现账户',
		identityVerification: '实名认证',
		logOut: '退出登录',
		logoutFailed: '登出失败，请稍后再试',
		groupManagement: '网站分组管理',
		omniGroupManagement: '群组管理',

		fundManagement: '资金管理',
		accountBalance: '账户余额',
		withdrawalDetail: '提现明细',
		riskManagement: '风险管理',
		chargebackManagement: '调单拒付管理',
		riskTransactionManagement: '风险订单管理',
		statement: '报表管理',
		pingpongCollection: 'PingPong 收款',
		currentsCollection: '分发账户',
		system: '系统管理',
		permission: '权限管理',
		keySetting: '密钥管理',
		transactionDetail: '交易明细',
		emailMsg: '邮件接收设置',
		paymentLink: '支付链',
		brandList: '品牌信息维护',
		templateManage: '模版管理',
		themeManage: '主题管理',
		modeManage: '模式管理',
		invoice: '发票',
		statementDownload: '对账单下载',
		transaction: '交易管理',
		refundLog: '退款查询',
		transitionLog: '交易查询',
		unsettledBalance: '待结算交易统计',
		blacklist: '黑名单管理',
		whitelist: '白名单管理',
		disputeManage: '争议订单管理'

	},
	webList: {
		accountChecking:
			'您的打款账户正在审核中，审核通过后，我们将开始为您自动打款。',
		accountNotAllow: '打款账户审核未通过，请尽快处理，以免影响您的资金流转。',
		accountNoAdd: '您还未添加打款账户,为了不影响您收到账款,请尽快添加。',
		addNow: '立即添加',
		addAgain: '重新提交',
		websiteTotal: '您一共添加了',
		website: '家网站',
		websites: '总计',
		approve: '正常运营',
		unbound: '等待授权',
		pending: '审核中',
		abnormal: '异常状态',
		addWebsite: '添加网站',
		group: '群组',
		settleCurrency: '结算币种',
		seeDetail: '网站详情',
		websiteHold:
			'很抱歉，您的网站被冻结，请联系客服，您当前的金额依然可以正常处理，但不再接受新的订单。',
		websiteClose:
			'很抱歉，您的网站已被关闭，请联系客服，您当前的金额依然可以正常处理，但不再接受新的订单。',
		websiteAbnormal: 'API状态异常，请及时重新授权，以免影响您的正常收单。',
		contact: '联系客服',
		reSubmit: '重新提交',
		modify: '修改',
		contactToAdd: '联系客服添加网站',
		noSuportAddBySelf:
			'目前我们暂不支持自主添加网站，请联系客服，客服会引导你进行审核资料的提交。给您带来的不便，非常抱歉。',
		pendingState: '系统审核中',
		successState: '审核通过',
		failState: '审核未通过',
		refuseState: '该店铺已关停',
		daysNeed: '请耐心等待',
		toBound: '审核通过，请耐心等待API授权',
		notFit: '由于存在合规问题，该店铺需要暂时关闭',
		declineText: '如有问题请联系客户经理',
		declineState: '审核未通过',
		reject: '网站审核不通过',
		reSubmitPlease: '请重新提交',
		copySuccess: '已复制到剪切板',
		copyFail: '复制失败，请稍后再试',
		websiteTooMuch: '网站数量已达上限',
		websiteMoreThanfifty: '您最多可添加50个网站',
		riskTips1st: '您有',
		riskTips2nt: '笔交易存在风险，请在交易发起的7天内联系持卡人进行确认，过期则交易自动撤销',
		riskTipsNoPermission: '笔风险订单，PingPong将会审核风险并做出决策，如有疑问请联系我们，感谢理解。',
		riskTips3rd: '笔交易存在风险，pingpong正在替您进行审核',
		dealImmediate: '马上处理',
		view: '查看'
	},
	upload: {
		uploadField: '上传文件',
		uploadFail: '文件上传失败，请重新上传',
		addPicture: '添加图片',
		reUpload: '重新上传',
		imgNotFit: '图片格式错误',
		imgToBe: '图片应为JPG、JPEG、PNG、BMP格式',
		tip: '注意',
		imgMax: '上传图片大小不能超过 1MB!',
		download: '下载：'
	},
	global: {
		netError: '网络请求超时，请稍后再试',
		netBusy: '网络繁忙，请稍后再试 (错误 ',
		flowDetail: '流水详情',
		flowId: '流水号',
		businessType: '业务类型',
		inComingTime: '退款入账时间',
		recordedTime: '入账时间',
		refundOriginTime: '退款金额',
		orderOriginAmount: '订单原始金额',
		exchangeRate: '汇率',
		refundAmount: '退款金额',
		recordedAmount: '入账金额',
		confirm: '确认',
		all: '全部',
		startDate: '开始时间',
		endDate: '结束时间',
		selectDate: '选择日期'
	},
	wthdraw: {
		warning: [
			'依据监管要求，订单信息将作为人民币结汇的依据，请保证信息的真实性，否则将影响款项到账。',
			'如您需要CNY结汇，请先至',
			' 订单管理 ',
			'补充信息。'
		]
	},
	wthdrawManual: {
		title: 'PingPongCheckout 提现操作指南',
		tips1: '1.PingPongcheckout 商户后台-右上角【账户中心】-【提现账户】，可申请添加银行账户或虚拟账户',
		tips2: '2.申请“添加银行账户”',
		tips3: '1)	支持添加同名的对公银行账户，支持美元、欧元、英镑、港币等多种币种。',
		tips4: '2)	添加之后需及时反馈BD去审核，审核之后即可操作提现到此账户。',
		tips5: '注：不支持直接提现人民币，若有人民币结汇需求，可提现到虚拟账户（VA账户），即按照如下3“申请虚拟账户”操作。',
		tips6: '3.申请虚拟账户（也称“VA” 账户）',
		tips7: '3.1首次申请流程',
		tips8: '待实名认证及店铺资料审核通过，即可申请添加，一个店铺只能申请一个虚拟账户，结算币种可以多选。',
		tips9: '注：账户名称是自定义的，自行填写虚拟账户名称，选择账户所支持的币种，点击确认；后续要添加虚拟账户的币种，可在虚拟账户详情中点击“添加币种”进行币种的添加即可。如第一次申请虚拟账户会跳转至PingPong收款页面进行信息填写，只需填写一次，之后再申请无需再填写，填写完成后将跳转回提现账户页面。',
		tips10: '1)	如您没有PingPong收款账户可以选择“立即注册绑定”可跳转注册页面；',
		tips11: '2)	如已拥有PingPong账户，点击页面【我已注册PingPong，立即登录绑定】，填写用户名密码登录及绑定；',
		tips12: '3)	如没有实名过，可勾选使用FI平台实名信息（即在PingPongCheckout的实名信息同步）可不再次填写；',
		tips13: '添加绑定完成将跳回提现账户页面，并且申请虚拟账户成功；',
		tips14: '4)	生成虚拟账户后在“账户中心”中会出现“PingPong收款”按钮，点击可直接跳转至PingPong收款网站进行人民币提现、供应商付款等操作。',
		tips15: '3.2非首次申请',
		tips16: '1)	在“账户中心”点击“提现账户”进入提现账户页面，在此页面可点击“申请虚拟账户”，须填写虚拟账户名称选择账户所支持的币种，点击确认，生成虚拟账户。如需添加虚拟账户的币种，可在虚拟账户详情中点击“添加币种”进行币种的添加；',
		tips17: '2)	生成虚拟账户后在“账户中心”中会出现“PingPong收款”按钮，点击可直接跳转至PingPong收款网站进行换汇操作；',
		tips18: '注:如需添加虚拟账户的币种，可在虚拟账户详情中点击“添加币种”进行币种的添加。',
		tips19: '4. PingPongcheckout 收单提现流程',
		tips20: '在网站【首页】或【资金管理】--【账户余额】中会显示目前可提现的金额，点击【提现】按钮，可选择要提现的银行卡或虚拟户。',
		tips21: '注意：',
		tips22: '1)	首次发起提现时，需要注意默认的提现账户，可点击右侧的”更改“，可切换提现账户；切换提现账户时，需提前创建对应的提现账户才可完成操作切换；',
		tips23: '2)	提现至虚拟户后可点击【账户中心】-【PingPong收款】跳转PingPong收款操作。',
		tips24: '5. 物流信息上传',
		tips25: '提现审核要求及人民币结汇要求，需补全商品物流信息。部分建站工具支持自动上传物流【如shopify、店匠等】，其他不支持自动上传的需手动补全物流。',
		tips26: '手动上传步骤如下： ',
		tips27: '点击【订单管理】-【上传状态】选择“未上传”，点击“导出当前结果”，将表格中的【商品名称、物流单号、物流公司、物流查询网址】补充完整，再点击“批量上传信息”将文件上传。（物流上传后大约半小时至1小时左右会同步结汇额度）',
		tips28: '6. PingPong收款平台操作流程',
		tips29: '6.1 添加提现账户',
		tips30: '点击【账户中心】-【PingPong收款】跳转PingPong收款平台，点击【账号中心】-【提现账户】，可在此页面点击“添加新账户”，添加您要提现的银行卡，添加银行卡后可对账户中的金额进行提现操作；',
		tips31: '6.2 收款提现流程',
		tips32: '通过点击【账户中心】-【PingPong收款】跳转PingPong收款平台。点击“立即提现”按钮，显示你可提现的币种金额。如有人民币提现需求的，商户在选中某个币种提现时，可看见可提现人民币的额度上限。',
		tips33: '点击“提现”跳转提现页面，可选择要提现的银行卡，根据选择银行卡支持的币种进行换汇，汇率显示在页面中，将按照汇率计算出预计到账金额，点击确认，换汇提现成功。',
		tips34: '可在提现明细中查看您提现的详情明细以及状态',
		tips35: '7. 提现常见问题',
		tips36: '(1) 提现到账时间',
		tips37: '一般1-3个工作日到账，如遇节假日会顺延。',
		tips38: '(2) 对公提现银行账户添加之后会显示审核中',
		tips39: '需反馈给对接的BD跟进审核，如未反馈，会一直显示审核中，无法进行下一步操作。',
		tips40: '(3) 提现收费',
		tips41: '提现按次/笔收费，具体费用参考签约的合同或联系对接BD。',
		tips42: '(4) 提现币种',
		tips43: '提现支持币种以商户后台实际展示币种为准，如有特殊需求，可提前与对接BD沟通。'
	},
	common: {
		cancel: '取消',
		confirm: '确认'
	}

}

export default zh
